import { Checkbox, FormControlLabel } from "@mui/material";
import { useFormikContext } from "formik";
import { AddSolutionFormValues } from "../../add/form/types";
import { EditSolutionFormValues } from "../../edit/form/types";
import { NOT_READY_FOR_SALE_REASON_FIELD } from "./NotReadyForSaleReasonSelect";

function ReadyForSaleCheckbox() {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();

  const handleChange = (
    _event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    context.setValues({
      ...context.values,
      "solution-is-ready-for-sale": checked,
      ...(checked && { [NOT_READY_FOR_SALE_REASON_FIELD]: null }),
    });
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          id="solution-is-ready-for-sale"
          checked={context.values["solution-is-ready-for-sale"]}
          onChange={handleChange}
          slotProps={{ input: { "aria-label": "Ready For Sale" } }}
        />
      }
      label="Ready for Sale"
    />
  );
}

export default ReadyForSaleCheckbox;
